(() => {
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', start, { once: true }); } else start();
  function start() {
  document.documentElement.classList.add('gg-home-enhanced');
  const placeholders = [...document.querySelectorAll('[data-gg-home-section]')];
  const loadedScripts = new Map();
  let resources;
  const scriptUrl = value => new URL(value, location.href).href;
  document.querySelectorAll('script[src]').forEach(script => loadedScripts.set(scriptUrl(script.src), Promise.resolve()));

  function loadScript(source, attributes = {}) {
    const url = scriptUrl(source);
    if (loadedScripts.has(url)) return loadedScripts.get(url);
    const promise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      for (const [name, value] of Object.entries(attributes)) if (!['src', 'defer', 'async'].includes(name)) script.setAttribute(name, value);
      script.async = false;
      script.src = url;
      script.onload = resolve;
      script.onerror = () => { loadedScripts.delete(url); script.remove(); reject(new Error('Resource unavailable')); };
      document.head.appendChild(script);
    });
    loadedScripts.set(url, promise);
    return promise;
  }

  function prepareResources() {
    if (resources) return resources;
    resources = (async () => {
      const template = document.getElementById('gg-home-gp-resources');
      if (!template) return;
      const fragment = template.content.cloneNode(true);
      const scripts = [...fragment.querySelectorAll('script')];
      scripts.forEach(script => script.remove());
      const styles = [...fragment.querySelectorAll('link[rel="stylesheet"]')];
      const ready = styles.map(link => new Promise((resolve, reject) => { link.onload = resolve; link.onerror = reject; }));
      document.head.appendChild(fragment);
      await Promise.all(ready);
      for (const script of scripts) {
        if (script.src) await loadScript(script.src, Object.fromEntries([...script.attributes].map(a => [a.name, a.value])));
      }
    })().catch(error => { resources = null; throw error; });
    return resources;
  }

  let running = 0;
  const queue = [];
  function enqueue(element) {
    if (!element || ['loading', 'queued', 'loaded'].includes(element.dataset.state)) return;
    element.dataset.state = 'queued';
    queue.push(element);
    drain();
  }
  function drain() {
    while (running < 2 && queue.length) {
      const element = queue.shift();
      running++;
      renderSection(element).finally(() => { running--; drain(); });
    }
  }

  async function renderSection(element) {
    element.dataset.state = 'loading';
    element.setAttribute('aria-busy', 'true');
    const wrapper = element.closest('.shopify-section');
    const url = new URL(location.href);
    url.searchParams.set('section_id', element.dataset.ggHomeSection);
    try {
      const [response] = await Promise.all([fetch(url.href, { credentials: 'same-origin' }), prepareResources()]);
      if (!response.ok) throw new Error('Section unavailable');
      const markup = await response.text();
      const doc = new DOMParser().parseFromString(markup, 'text/html');
      const section = doc.getElementById('shopify-section-' + element.dataset.ggHomeSection);
      if (!section || section.querySelector('[data-gg-home-section]')) throw new Error('Section unavailable');
      const scriptNodes = [...section.querySelectorAll('script')];
      const executable = scriptNodes.filter(script => !script.type || ['text/javascript', 'module'].includes(script.type));
      const external = executable.filter(script => script.src || script.hasAttribute('delay')).map(script => ({ src: script.getAttribute('src') || script.getAttribute('delay'), attributes: Object.fromEntries([...script.attributes].map(a => [a.name, a.value])) }));
      const inline = executable.filter(script => !script.src && !script.hasAttribute('delay')).map(script => script.textContent);
      executable.forEach(script => script.remove());
      wrapper.innerHTML = section.innerHTML;
      for (const script of external) await loadScript(script.src, script.attributes);
      for (const code of inline) {
        const script = document.createElement('script');
        script.textContent = code;
        wrapper.appendChild(script);
      }
      wrapper.dataset.ggHomeLoaded = 'true';
      wrapper.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true, detail: { sectionId: element.dataset.ggHomeSection } }));
      window.dispatchEvent(new Event('resize'));
      window.dispatchEvent(new Event('scroll'));
      document.dispatchEvent(new CustomEvent('gg:home-section-loaded', { detail: { sectionId: element.dataset.ggHomeSection } }));
    } catch (error) {
      if (element.isConnected) {
        element.dataset.state = 'error';
        element.removeAttribute('aria-busy');
        const retry = element.querySelector('[data-gg-home-retry]');
        if (retry) retry.hidden = false;
      } else {
        wrapper.dataset.ggHomeLoadError = 'true';
      }
    }
  }
  placeholders.forEach(element => element.querySelector('[data-gg-home-retry]')?.addEventListener('click', () => enqueue(element)));

  let activated = false;
  function scanNearViewport() {
    placeholders.filter(element => element.isConnected && element.dataset.state === 'pending').forEach(element => { const rect = element.getBoundingClientRect(); if (rect.height > 0 && rect.bottom >= -1000 && rect.top <= innerHeight + 1000) enqueue(element); });
  }
  function activate() {
    if (activated) return;
    activated = true;
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting) { observer.unobserve(entry.target); enqueue(entry.target); }
      }), { rootMargin: '1000px' });
      placeholders.forEach(element => observer.observe(element));
    } else placeholders.forEach(enqueue);
    scanNearViewport();
  }
  const critical = [...document.querySelectorAll('[data-gg-home-critical]')].find(image => image.getBoundingClientRect().width > 0);
  const ready = critical?.decode ? critical.decode().catch(() => {}) : Promise.resolve();
  Promise.race([ready, new Promise(resolve => setTimeout(resolve, 12000))]).then(activate);
  let scanTimer;
  window.addEventListener('scroll', () => { if (scrollY > 100) activate(); if (!scanTimer && activated) scanTimer = setTimeout(() => { scanTimer = null; scanNearViewport(); }, 100); }, { passive: true });
  window.addEventListener('resize', () => { if (activated) scanNearViewport(); });

  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  document.querySelectorAll('[data-gg-home-video]').forEach(video => {
    const prepare = () => {
      video.poster = video.dataset.poster;
      if (reduced.matches) return;
      const source = video.querySelector('source');
      if (!source.src) { source.src = source.dataset.src; video.load(); }
      video.play().catch(() => { video.controls = true; });
    };
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => entries.forEach(entry => { if (entry.isIntersecting) ready.then(prepare); else video.pause(); }), { rootMargin: '100px' });
      observer.observe(video);
    } else ready.then(prepare);
  });
  }
})();
